module.exports = __webpack_public_path__ + "static/menuekarte-a1f3ea1f604f4032a8df9b7c5b0887c1.jpg";